import { Box, CircularProgress, Divider, Stack } from "@mui/material";
import { Typography } from "@mui/material";
import { IconButton } from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { BracketRoundHeader } from "./Match Play Bracket/BracketRoundHeader";
import { createMatchBracketOrder } from "./Match Play Bracket/BracketOrder";
import { MatchBox } from "./Match Play Bracket/MatchBox";
import { useEffect, useState } from "react";
import { useTBContext } from "../Contexts/useTBStates";

interface MatchPlayTeeSheetProps {
    /* event: any;
    viewEventData: any;
    roundValue: number; */
   /*  factor: number; */
    /* editMode: boolean; */
   /*  appTheme: any; */
    createTeeTime: (startingTime: string, row: number) => Date;
    /* setViewEventData: React.Dispatch<React.SetStateAction<any>>; */
}

export const MatchPlayTeeSheet = ({ /* event, viewEventData, roundValue, */ /* factor,  *//* editMode,  *//* appTheme,  */createTeeTime, /* setViewEventData */ }: MatchPlayTeeSheetProps) => {

    const {
        viewEvent,
        viewEventData,
        roundValue,
        factor, appTheme
      } = useTBContext();

    
    // Gets the initital match values
    const matchTotal = viewEvent.playerCap - 1;
    const bracketRegions = viewEvent.rounds[roundValue-1].matchRegions;
    const regionRounds = viewEvent.rounds[roundValue-1].matchRegionRounds;
    const matchReg = viewEventData.registrations;
    const matchScores = viewEventData.scores;

    // Sets the match layout values
    const matchSpacing = 2*factor;
    const baseHeight = 60*factor;
    const baseWidth = 125*factor;
    const spaceHeight = 35*factor;

    // Creates the match bracket order
    const matchOrder = createMatchBracketOrder(viewEvent.playerCap, bracketRegions, regionRounds);
    console.log(matchOrder);

    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        if (matchOrder.length > 0 && matchOrder) {
            setIsLoading(false);
        }
    }, [matchOrder]);

    const matchBlock = () => {

        return (
            <Box> {isLoading ? (
                <Box id='tournament-builder-loading-box'
                    sx={{ 
                        display: isLoading ? 'flex' : 'none', 
                        justifyContent: 'center', 
                        alignItems: 'center', 
                        height: '100vh',
                        width: '100%',
                        transition: 'opacity 0.5s ease-in-out',
                        opacity: isLoading ? 1 : 0,
                        pointerEvents: isLoading ? 'auto' : 'none'
                    }}
                    className={isLoading ? 'loading-transition' : 'loading-hidden'}
                    >
                    <Typography variant="h6">Loading...</Typography>
                    <CircularProgress />
                </Box>
            ) : (
                <Stack direction='row' width={'100%'}>
                    {/* Left Side Brackets */}
                    <Stack direction={'column'} spacing={matchSpacing*2}>
                        {Array.from({ length: Math.log2(bracketRegions) || 1}, (_, regionIndex) => regionIndex).map((regionIndex) => (
                            <Stack key={`L${regionIndex}`} direction={'row'}>
                                {Array.from({ length: regionRounds }, (_, index) => regionRounds - 1 - index).map((index) => (
                                    <Stack key={`L${regionIndex}-${index}`} 
                                        direction='column'
                                        spacing={matchSpacing}
                                    >
                                        {regionIndex === 0 && <BracketRoundHeader index={index} bracketRegions={bracketRegions} factor={factor} />}
                                        {Array.from({ length: Math.pow(2, index) }).map((_, indexCol) => (
                                            <MatchBox 
                                                key={`L${regionIndex}-${index}-${indexCol}`}
                                                matchReg={matchReg}
                                                side='left' 
                                                index={index} 
                                                indexCol={indexCol} 
                                                regionRounds={regionRounds} 
                                                matchOrder={matchOrder.filter((match: any) => match.region === regionIndex*2)[indexCol]}
                                                regionIndex={regionIndex}
                                                baseWidth={baseWidth}
                                                baseHeight={baseHeight}
                                                spaceHeight={spaceHeight}
                                                /* factor={factor} 
                                                appTheme={appTheme}*/ />
                                        ))}
                                        {regionIndex === 0 && bracketRegions === 4 && 
                                            <Stack direction='row' height={matchSpacing*10} justifyContent='center' alignItems='center'> 
                                                <Box sx={{width: '100%', height: matchSpacing*10, borderBottom: `1px dashed ${appTheme.palette.primary.main}`}}/>
                                            </Stack>
                                        }
                                    </Stack>
                                ))}
                                
                            </Stack>
                        ))}
                    </Stack>
                    {bracketRegions === 4 && (
                        <Stack key={'left-semifinals'} direction='column' spacing={matchSpacing}>
                            <BracketRoundHeader index={-1} bracketRegions={bracketRegions} factor={factor} />
                            <MatchBox 
                                key={'left-semifinals-matchbox'}
                                matchReg={matchReg}
                                side='left' 
                                index={-1} 
                                indexCol={0} 
                                regionRounds={regionRounds} 
                                matchOrder={matchOrder.filter((match: any) => match.region === 0)[0]}
                                regionIndex={regionRounds}
                                baseWidth={baseWidth}
                                baseHeight={baseHeight+matchSpacing*5}
                                spaceHeight={spaceHeight}
                                /* factor={factor} 
                                appTheme={appTheme} */ />
                        </Stack>
                    )}
                    
                    {bracketRegions > 1 && <Stack direction='column'  /* width={150} height={'100%'} */ justifyContent='center'>
                        <BracketRoundHeader index={bracketRegions === 4 ? -2 : -1} bracketRegions={bracketRegions} factor={factor} />

                        <Stack direction='column' spacing={matchSpacing} height={'100%'} justifyContent='center'>
                            <Stack direction='column' width={baseWidth*1.25}>
                                <Stack direction='column' width={'75%'}  borderBottom={`1px solid ${appTheme.palette.primary.main}`}>
                                    <Typography sx={{ marginLeft: 1, height: 15*factor, fontSize: 12*factor}}>Bracket 1</Typography>
                                </Stack>
                            </Stack>

                            <Stack direction='column' width={baseWidth*1.25} height={baseHeight*1.5} justifyContent='center' alignItems='center'>
                                <Stack direction='column' width={'75%'} height={'75%'} display='flex' justifyContent='center' alignItems='center' border={`1px solid ${appTheme.palette.primary.main}`}>
                                    <Typography>TBD</Typography>
                                    <Typography>1-0-1</Typography>
                                </Stack>
                            </Stack>

                            <Stack direction='column' width={baseWidth*1.25} alignItems='flex-end'>
                                <Stack direction='column' width={'75%'}  borderBottom={`1px solid ${appTheme.palette.primary.main}`}>
                                    <Typography sx={{ marginRight: 1, textAlign: 'right', height: 15*factor, fontSize: 12*factor}}>Bracket 2</Typography>
                                </Stack>
                            </Stack>
                        </Stack>

                        <BracketRoundHeader index={bracketRegions === 4 ? -3 : -2} bracketRegions={bracketRegions} factor={factor}/>

                    </Stack>}
                    
                    {bracketRegions === 4 && (

                        <Stack key={'right-semifinals'} direction='column' spacing={matchSpacing}>
                            <BracketRoundHeader index={-1} bracketRegions={bracketRegions} factor={factor} />
                            <MatchBox 
                                key={'right-semifinals-matchbox'}
                                matchReg={matchReg}
                                side='right' 
                                index={-1} 
                                indexCol={0} 
                                regionRounds={regionRounds} 
                                matchOrder={matchOrder.filter((match: any) => match.region === 0)[0]}
                                regionIndex={regionRounds}
                                baseWidth={baseWidth}
                                baseHeight={baseHeight+matchSpacing*5}
                                spaceHeight={spaceHeight}
                                /* factor={factor} 
                                appTheme={appTheme} */ />
                        </Stack>

                    )}
   

                    {/* Left Side Brackets */}
                    <Stack direction={'column'} spacing={matchSpacing*2}>
                        {Array.from({ length: Math.log2(bracketRegions)}, (_, regionIndex) => regionIndex).map((regionIndex) => (
                            <Stack key={`R${regionIndex}`} direction={'row'}>
                                {Array.from({ length: regionRounds }, (_, index) => index).map((index) => (
                                    <Stack key={`R${regionIndex}-${index}`} direction='column' spacing={matchSpacing}>
                                        {regionIndex === 0 && <BracketRoundHeader index={index} bracketRegions={bracketRegions} factor={factor} />}
                                        {Array.from({ length: Math.pow(2, index) }).map((_, indexCol) => (
                                            <MatchBox 
                                                key={`R${regionIndex}-${index}-${indexCol}`}
                                                matchReg={matchReg}
                                                side='right'
                                                index={index} 
                                                indexCol={indexCol} 
                                                regionRounds={regionRounds} 
                                                matchOrder={matchOrder.filter((match: any) => match.region === regionIndex*2+1)[indexCol]}
                                                regionIndex={regionIndex}
                                                baseWidth={baseWidth}
                                                baseHeight={baseHeight}
                                                spaceHeight={spaceHeight}
                                               /*  factor={factor} 
                                                appTheme={appTheme} */ />

                                        ))}
                                        {regionIndex === 0 && bracketRegions === 4 && 
                                            <Stack direction='row' height={matchSpacing*10} justifyContent='center' alignItems='flex-end'> 
                                                <Box sx={{width: '100%', height: matchSpacing*2, borderBottom: `1px dashed ${appTheme.palette.primary.main}`}}/>
                                            </Stack>
                                        }
                                    </Stack>
                                ))}
                            </Stack>
                        ))}
                    </Stack>
                    
                </Stack>
            )}
            </Box>
        )
    }

    return (
        <Box padding={1}>
            {matchBlock()}
        </Box>
    )
}
